var path = 'src/app/patients/pregnancies/pregnancies.html';
var html = "<h1 class=page-header>Pregnancies</h1> <div pregnancies-component patient=patient></div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/patients/pregnancies/pregnancies.html
 ** module id = 559
 ** module chunks = 0
 **/